export const API_URL = "/back"
//export const API_URL = "https://localhost:7292"